import React from "react";
import { Button, Tag } from "antd";
import DynamicTable from "../../../components/DynamicTable";
import { date } from "../formatters";

function AwardsTable({ data, busy, page, setPage, onReverse }) {
  const columns = [
    {
      title: "Award",
      dataIndex: "id",
    },
    {
      title: "Student",
      dataIndex: "user_id",
    },
    {
      title: "Source",
      dataIndex: "source",
    },
    {
      title: "Points",
      dataIndex: "points",
    },
    {
      title: "Unspent",
      dataIndex: "remaining",
    },
    {
      title: "Status",
      dataIndex: "state",
      render: (x) => <Tag>{x}</Tag>,
    },
    {
      title: "Available",
      dataIndex: "available_at",
      render: date,
    },
    {
      title: "Expiry",
      dataIndex: "expires_at",
      render: date,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, row) => (
        <Button
          danger
          disabled={["expired", "reversed"].includes(row.state)}
          onClick={() => {
            onReverse(row);
          }}
        >
          Reverse
        </Button>
      ),
    },
  ];

  return (
    <>
      <DynamicTable
        showAction={false}
        loading={busy}
        rowKey="id"
        dataSource={data.awards}
        columns={columns}
        scroll={{
          x: 1100,
        }}
        pagination={{
          current: page + 1,
          pageSize: 50,
          total: data.award_count,
          showSizeChanger: false,
          onChange: (p) => setPage(p - 1),
        }}
      />
    </>
  );
}
export default AwardsTable;
